export const selectPendingInvestments = (state) => {
  return {
    pendingInvestments: state.dashboard.pendingData.investments,
  };
};

export default {
  selectPendingInvestments,
};
